





















































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";

const realName = () => import("@/components/realName.vue");
import {
  queryCurrent,
  bindWechat,
  verifyWechat,
  getBindCode,
  bindMobile,
  changeBindWx,
  verifyBindWx,
  changePassword,
  changeAlipay,
  changeNickName,
  logOff,
} from "@/api/user/user";
import QRCode from "qrcodejs2";

@Component({
  components: {
    realName,
  },
})
export default class Account extends Vue {
  private keyword: string = process.env.VUE_APP_KEYWORD;
  private phone;
  private verifyPhoneFormat: boolean = false;
  // 计时器,注意需要进行销毁
  private timeCounter: any = null;
  private timeValidateCounter: any = null;
  // null 则显示按钮 秒数则显示读秒
  private showtime: any = null;
  private code;
  private modifyWx: boolean = false;
  private changeWxToken = "";
  private modifyPassword: boolean = false;
  private modifyPasswordTitle = "";
  private modifyAlipay: boolean = false;
  private modifyAlipayTitle = "";
  private modifyLogout: boolean = false;
  private realNameShow: boolean = false;
  private modifyPhone: boolean = false;
  private modifyNick: boolean = false;
  private nick = "";
  private name;
  private number;
  private alipay = "";
  private logoutReason = "";
  private hoverPassword = false;
  private hoverRealName = false;
  private hoverPhone = false;
  private hoverWx = false;
  private hoverAlipay = false;
  private hoverLogout = false;
  private realNameData: object = {
    name: "",
    identity_card: "",
  };
  private realNameMsg: string[] = [
    "信息必须真实有效，填写无效信息无法进行提现",
    "请确保您的支付宝或微信账号与实名认证信息相符合，负责将无法进行提现",
  ];

  private password: object = {
    firstPassword: "",
    secondPassword: "",
  };

  private rulePasswordValidate: object = {
    firstPassword: [{ required: true, message: "请输入密码", trigger: "blur" }],
    secondPassword: [
      { required: true, message: "请再次输入密码", trigger: "blur" },
    ],
  };

  private created() {
    this.$store.dispatch("initUserInfo");
  }

  private hoverModify(type) {
    switch (type) {
      case 0:
        this.hoverPassword = true;
        break;
      case 1:
        this.hoverRealName = true;
        break;
      case 2:
        this.hoverPhone = true;
        break;
      case 3:
        this.hoverWx = true;
        break;
      case 4:
        this.hoverAlipay = true;
        break;
      case 5:
        this.hoverLogout = true;
        break;
    }
  }

  private clearHover() {
    this.hoverPassword = false;
    this.hoverRealName = false;
    this.hoverPhone = false;
    this.hoverWx = false;
    this.hoverAlipay = false;
    this.hoverLogout = false;
  }

  // 姓名隐藏
  private getName(name) {
    if (!name || name == "") {
      return "";
    }
    let returnName = "";
    for (let i = 0; i < name.length - 1; i++) {
      returnName += "*";
    }
    returnName += name[name.length - 1];
    return returnName;
  }

  get userInfo() {
    var user = this.$store.state.userInfo;
    if (user && user.mobile) {
      var reg = /^(\d{3})\d{4}(\d{4})$/;
      user.phone = user.mobile.replace(reg, "$1****$2");

      user.hiddenName = this.getName(user.real_name);
      user.name = user.real_name;
      this.realNameData = {
        real_name: user.name,
        identity_card: user.id_card,
      };
    }
    return user;
  }

  private async handleToModifyWx() {
    const self = this;
    const res = (await changeBindWx()) as any;
    if (res.code == 200) {
      this.changeWxToken = res.result.token;
      document.getElementById("qrcode").innerHTML = "";
      const qrcode = new QRCode("qrcode", {
        width: 180,
        height: 180,
        text: res.scan_url, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });
      qrcode.clear();
      qrcode.makeCode(res.result.scan_url);
      this.modifyWx = true;

      self.timeValidateCounter = setTimeout(this.validateChange, 1000);
    }
  }

  private async handleToModifyLogout() {
    this.modifyLogout = true;
  }

  private async validateChange() {
    if (this.timeValidateCounter == null || !this.modifyWx) {
      return false;
    }
    const validate = (await verifyBindWx(this.changeWxToken)) as any;

    if (validate.code == 200) {
      this.timeValidateCounter = null;
      this.modifyWx = false;
      const resp: any = await queryCurrent("");
      this.$store.commit("setUser", resp);
      this.$Message.success("立即修改微信号成功");
    } else if (validate.code == 201) {
      this.timeValidateCounter = setTimeout(this.validateChange, 1000);
    } else {
      this.$Message.error(validate.result);
    }
  }

  private newPhone(e) {
    this.phone = e;

    if (e.length == 11) {
      this.verifyPhoneFormat = true;
    } else {
      this.verifyPhoneFormat = false;
    }
  }

  private newAlipay(e) {
    this.alipay = e;
  }

  private newNick(e) {
    this.nick = e;
  }

  private inputCode(e) {
    this.code = e;
  }

  private logoutDesc(e) {
    this.logoutReason = e;
  }

  private async changeMobile() {
    if (!/^1[3456789]\d{9}$/.test(this.phone)) {
      this.$Message.error("手机号码有误，请重填");
      return false;
    }
    if (!/^\d{6}$/.test(this.code)) {
      this.$Message.error("验证码有误，请重填");
      return false;
    }

    const res = (await bindMobile({
      mobile: this.phone,
      code: this.code,
    })) as any;
    if (res.code == 200) {
      const resp: any = await queryCurrent("");
      this.$store.commit("setUser", resp);
      this.$Message.success("绑定成功");
      this.modifyPhone = false;
    } else {
      this.$Message.success(res.message);
    }

    console.log(this.$store.state.userInfo);
  }

  private sendSms() {
    if (!/^1[3456789]\d{9}$/.test(this.phone)) {
      this.$Message.info("手机号码有误，请重填");
      return false;
    }
    getBindCode({ mobile: this.phone });
    this.countDown(60);
  }

  // 倒计时 60秒
  private countDown(times) {
    const self = this;
    // 时间间隔 1秒
    const interval = 1000;
    let count = 0;
    self.timeCounter = setTimeout(countDownStart, interval);

    function countDownStart() {
      if (self.timeCounter == null) {
        return false;
      }
      count++;
      self.countDownText(times - count + 1);
      if (count > times) {
        clearTimeout(self.timeCounter);
        self.showtime = null;
      } else {
        self.timeCounter = setTimeout(countDownStart, interval);
      }
    }
  }

  private countDownText(s) {
    this.showtime = `${s}秒后重新发送`;
  }

  private handleModifyPassword(type) {
    if ((type = 1)) {
      this.modifyPasswordTitle = "设置登录密码";
    } else {
      this.modifyPasswordTitle = "立即修改登录密码";
    }
    this.modifyPassword = true;
  }

  // 关闭实名认证弹窗
  private async closeRealName(submit) {
    this.realNameShow = false;
  }

  private async showRealNameDialog() {
    this.realNameShow = true;
  }

  private handleToModifyAlipay(type) {
    if ((type = 1)) {
      this.modifyAlipayTitle = "设置绑定支付宝";
    } else {
      this.modifyAlipayTitle = "立即修改绑定支付宝";
    }
    this.modifyAlipay = true;
  }

  private async handleToChangePassword() {
    var first = (this.password as any).firstPassword;
    var second = (this.password as any).secondPassword;
    if (first == second) {
      const res = (await changePassword(first)) as any;
      if (res.code == 200) {
        const resp: any = await queryCurrent("");
        this.$store.commit("setUser", resp);
        this.$Message.success("立即修改成功");
        this.modifyPassword = false;
      } else {
        this.$Message.error(res.message);
      }
    } else {
      this.$Message.error("两次密码不一致");
    }
  }

  private async handleToChangeLogout() {
    let self = this;
    if (!this.logoutReason) {
      this.$Message.error("请输入注销原因");
      return;
    }
    this.$Modal.confirm({
      title: "确定注销？",
      content:
        "注意：账户注销成功后，用户信息（包含身份实名信息、余额等）不能再次使用注册，也无法找回，请您谨慎操作！！！其他问题可以联系客服解决",
      okText: "确认注销",
      cancelText: "我再想想",
      onOk: () => {
        self.handleConfirmLogout();
      },
    });
  }

  private async handleConfirmLogout() {
    // 注销
    const res = await logOff({
      reason: this.logoutReason,
    });
    console.log(res);
    this.modifyLogout = false;
    if ((res as any).code == 200) {
      this.$store.dispatch("logoutUser");
      this.$router.push({ path: "/" });
      this.$Message.success("注销成功");
    }
  }

  private async handleToChangeAlipay() {
    if (this.alipay && this.alipay != "") {
      const res = (await changeAlipay(this.alipay)) as any;
      if (res.code == 200) {
        const resp: any = await queryCurrent("");
        this.$store.commit("setUser", resp);
        this.$Message.success("立即修改成功");
        this.modifyAlipay = false;
      } else {
        this.$Message.success(res.message);
      }
    } else {
      this.$Message.error("支付宝账号不能为空");
    }
  }
}
